import * as ActionsAuth from "./Action";

export default {
  ...ActionsAuth,
};
